export default function ProfileChart({ p }) {
  const W = 640, H = 220, pad = 28;
  const pts = p.points;
  const lo = Math.min(...pts.map((r) => r.ground)) - 5;
  const hi = Math.max(...pts.map((r) => Math.max(r.terrain, r.los + r.f1))) + 5;
  const x = (d) => pad + (d / p.distance_m) * (W - 2 * pad);
  const y = (h) => H - pad - ((h - lo) / (hi - lo)) * (H - 2 * pad);
  const line = (f) => pts.map((r, i) => `${i ? "L" : "M"}${x(r.d).toFixed(1)},${y(f(r)).toFixed(1)}`).join(" ");
  const terrain = `${line((r) => r.terrain)} L${x(p.distance_m)},${H - pad} L${x(0)},${H - pad} Z`;
  const color = { ok: "#10b981", warn: "#f59e0b", error: "#ef4444" }[p.level];
  const w = p.worst || {};
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full bg-slate-950 rounded border border-slate-800" data-testid="wifi-profile-chart">
      <path d={terrain} fill="#78350f" fillOpacity="0.55" stroke="#d97706" strokeWidth="1" />
      <path d={line((r) => r.los + r.f1)} fill="none" stroke="#22d3ee" strokeDasharray="4 3" strokeWidth="1" />
      <path d={line((r) => r.los - r.f1)} fill="none" stroke="#22d3ee" strokeDasharray="4 3" strokeWidth="1" />
      <path d={line((r) => r.los - 0.6 * r.f1)} fill="none" stroke="#a78bfa" strokeDasharray="2 3" strokeWidth="0.8" />
      <path d={line((r) => r.los)} fill="none" stroke={color} strokeWidth="1.8" />
      {w.d != null && <circle cx={x(w.d)} cy={y(w.terrain)} r="4" fill={color} data-testid="wifi-profile-worst" />}
      <text x={pad} y={14} fill="#94a3b8" fontSize="10">A {p.a.abs_m} m n.p.m.</text>
      <text x={W - pad} y={14} fill="#94a3b8" fontSize="10" textAnchor="end">B {p.b.abs_m} m n.p.m.</text>
      <text x={pad} y={H - 8} fill="#64748b" fontSize="9">0 km</text>
      <text x={W - pad} y={H - 8} fill="#64748b" fontSize="9" textAnchor="end">{(p.distance_m / 1000).toFixed(2)} km</text>
      <text x={W / 2} y={H - 8} fill="#64748b" fontSize="9" textAnchor="middle">teren + krzywizna Ziemi (k=4/3){p.clutter_m ? ` + ${p.clutter_m} m przeszkód` : ""} · F1 (niebieski) · 60% F1 (fiolet)</text>
    </svg>
  );
}
